/*
 * Title: Auth/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import Auth component form containers.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import Signup from "@pages/creator/Signup";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

const vh = window.innerHeight * 0.01;

type Props = {
  name: string;
};

const IndexPage: React.FC<Props> = (props) => {
  const { actions } = require("@redux/UserRedux");
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);

  React.useEffect(() => {
    dispatch(actions.addFormStep(4))
  }, []);

  return (
    <div
      style={{ height: vh * 100 }}
      className="bg-black overflow-hidden h-[100vh] max-h-[100vh] relative">
      {user.token && <Navigate to="/home" />}

      <Signup />
    </div>
  );
};

export default IndexPage;
